import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import RestaurantIcon from '../../../public/images/icons/restaurant-map.png';
import UserIcon from '../../../public/images/icons/user-map.png';

const google = window.google;

class Map extends Component {
  constructor(props) {
    super(props);
    this.setRestaurantLocations = this.setRestaurantLocations.bind(this);
    this.setRoute = this.setRoute.bind(this);
    this.initMap = this.initMap.bind(this);
  }

  setRoute() {
    const map = this.initMap(
      this.props.end.sourcelat,
      this.props.end.sourcelng
    );
    const directionsService = new google.maps.DirectionsService();
    const rendererOptions = {
      map: map,
      suppressMarkers: true,
    };

    const directionsDisplay = new google.maps.DirectionsRenderer(
      rendererOptions
    );
    directionsDisplay.setMap(map);

    directionsService.route(
      {
        origin: {
          lat: this.props.start.sourcelat,
          lng: this.props.start.sourcelng,
        },
        destination: this.props.end,
        travelMode: 'DRIVING',
      },
      function(response, status) {
        if (status === 'OK') {
          directionsDisplay.setDirections(response);
          const myRoute = response.routes[0].legs[0];

          const endMarker = new google.maps.Marker();
          endMarker.setMap(map);
          endMarker.setPosition(
            myRoute.steps[myRoute.steps.length - 1].end_point
          );
          endMarker.setIcon(UserIcon);

          if (
            myRoute.steps[myRoute.steps.length - 1].end_point.lat() !==
              myRoute.steps[0].start_point.lat() &&
            myRoute.steps[myRoute.steps.length - 1].end_point.lng() !==
              myRoute.steps[0].start_point.lng()
          ) {
            const startMarker = new google.maps.Marker();
            startMarker.setMap(map);
            startMarker.setPosition(myRoute.steps[0].start_point);
            startMarker.setIcon(RestaurantIcon);
          }
        }
      }
    );
  }

  initMap(lat, lng) {
    return new google.maps.Map(document.getElementById('map'), {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      fullscreenControl: false,
    });
  }

  setRestaurantLocations() {
    const locations = this.props.maplocations;
    const numberOfLocations = locations.length;
    if (numberOfLocations > 0) {
      const map = this.initMap(locations[0].sourcelat, locations[0].sourcelng);
      let marker;
      for (let i = 0; i < numberOfLocations; i++) {
        marker = new google.maps.Marker({
          position: new google.maps.LatLng(
            locations[i].sourcelat,
            locations[i].sourcelng
          ),
          map: map,
          icon: RestaurantIcon,
        });

        google.maps.event.addListener(marker, 'click', function(marker, i) {
          return function() {
            const infowindow = new google.maps.InfoWindow();
            infowindow.setContent(this.formattedAddress(locations[i]));
            infowindow.open(map, marker);
          };
        });
      }
    } else {
      new google.maps.Map(document.getElementById('map'), {
        center: new google.maps.LatLng(40.00658, -100.810547),
        zoom: 3,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });
    }
  }

  componentDidMount() {
    this.forceUpdate();
  }

  componentDidUpdate() {
    if (this.props.start && this.props.end) {
      this.setRoute();
    } else {
      this.setRestaurantLocations();
    }
  }

  render() {
    return (
      <div
        id="map"
        style={{
          height: this.props.start && this.props.end ? '200px' : '400px',
        }}
      >
        <span />
      </div>
    );
  }
}

Map.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Map);



// WEBPACK FOOTER //
// ./src/views/orderType/components/Map.jsx